import { trpc } from '@/shared/api';
import { usePresignedImageUpload } from '@/shared/lib';

/** 기업 로고 업로드 — 발급(landing.presignPartnerUpload) → S3 직접 PUT. */
export const useLandingPartnerUpload = () => {
  const presignMutation = trpc.landing.presignPartnerUpload.useMutation();

  return usePresignedImageUpload((contentType) => presignMutation.mutateAsync({ contentType }));
};
